export function setupGuard(router) {
  router.beforeEach((to, from) => {
  })

  router.afterEach((to, from) => {

  })
  
}
